/**
 * @项目名称
 */
export const PROJECT_NAME = 'shh_bocom'
/**
 * @默认路径
 */
export const DEFAULT_ROUTE = { path: '/home/dashboard', label: '仪表盘' }
